import { FormControl, InputLabel, NativeSelect, type Theme } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { createStyles, makeStyles, withStyles } from "@mui/styles";
import type { FC } from "react";

interface SelectFilterProps {
    className?: string;
    filters: any[];
    filterLabel: string;
    handleFilter: (id: any) => void;
    disabled?: boolean;
    value?: number | string;
}

const BootstrapInput = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "label + &": {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 4,
            position: "relative",
            backgroundColor: theme.palette.background.paper,
            border: "1px solid #ced4da",
            fontSize: 16,
            padding: "10px 26px 10px 12px",
            transition: theme.transitions.create(["border-color", "box-shadow"]),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "Roboto",
                '"Helvetica Neue"',
                "Arial",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(","),
            "&:focus": {
                borderRadius: 4,
                borderColor: "#80bdff",
                boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
            },
        },
    })
)(InputBase);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        margin: {
            margin: theme.spacing(1),
        },
    })
);

export const SelectFilter: FC<SelectFilterProps> = ({
    filters,
    filterLabel,
    handleFilter,

    disabled,
    value,
}) => {
    const classes = useStyles();

    const handleChange = (event) => {
        const filterValue = event.target.value as number;
        handleFilter(filterValue);
    };

    return (
        <FormControl className={classes.margin}>
            <InputLabel htmlFor="filter-select-native">{filterLabel}</InputLabel>
            <NativeSelect
                id="filter-select-native"
                disabled={disabled}
                value={value}
                onChange={handleChange}
                input={<BootstrapInput />}
            >
                {filters.map((filter, index) => {
                    return (
                        <option key={index} value={filter.id}>
                            {filter.name}
                        </option>
                    );
                })}
            </NativeSelect>
        </FormControl>
    );
};

export default SelectFilter;
